import { FinanceLabField, getFinanceLabMetrics } from "@/entities/FinanceLab";
import { useApiQuery } from "@/api";
import { getLastValue } from "@/utils/metrics/metricsUtils";
import { ExpandableMarkdown } from "../../components/ExpandableMarkdown";
import { LabelLLM } from "../../components/LabelLLM";
import { useAtomValue } from "jotai";
import { showDataSourcesAtom } from "../../state";
import { SourceTag } from "../../components/SourceTag";
import { MetricSource } from "@/features/Metrics/Metrics.types";

export function TransactionSummary() {
    const { data: summary } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.DEAL_TRANSACTION_SUMMARY],
        },
    });
    const showDataSources = useAtomValue(showDataSourcesAtom);

    const summaryText =
        getLastValue(summary?.[0]?.values)?.formattedValue || "-";

    return (
        <div>
            <div className="mb-2">
                <ExpandableMarkdown text={summaryText} maxLength={1800} />
            </div>
            {showDataSources && (
                <SourceTag
                    source={MetricSource.FINANCE_LAB}
                    fieldName={FinanceLabField.DEAL_TRANSACTION_SUMMARY}
                />
            )}
            <LabelLLM />
        </div>
    );
}
